import type { CSSInterpolation } from '@emotion/serialize';
import { useTranslation } from 'react-i18next';

import IconGear from '~icons/bi/gear';

import {
	Menu,
	MenuButton,
	MenuLink,
	useCallout,
} from '@adflow/frontend/ui-common';
import { useAbility } from '@adflow/frontend/util-auth';

interface GearMenuProps {
	iconButtonStyle: CSSInterpolation;
}

export function GearMenu({ iconButtonStyle }: GearMenuProps) {
	const { t } = useTranslation('common');

	const { ability, missingPermissionText } = useAbility();

	const {
		callout: missingListRolesPermCallout,
		setShowViewCallout: showNoListRolesPermCallout,
	} = useCallout({
		text: missingPermissionText('list', 'Role'),
	});

	const {
		callout: missingListUsersPermCallout,
		setShowViewCallout: showNoListUsersPermCallout,
	} = useCallout({
		text: missingPermissionText('list', 'User'),
	});

	return (
		<>
			<Menu
				trigger={
					<MenuButton css={iconButtonStyle} data-testid="gear-menu">
						<IconGear css={{ width: '1em', height: '1em' }} />
					</MenuButton>
				}
			>
				<MenuLink
					to="/users"
					disabled={ability.cannot('list', 'User')}
					onDisabledClick={showNoListUsersPermCallout}
					data-testid="gear-menu-users"
				>
					{t('sections.users')}
				</MenuLink>
				<MenuLink
					to="/roles"
					disabled={ability.cannot('list', 'Role')}
					onDisabledClick={showNoListRolesPermCallout}
				>
					{t('sections.roles')}
				</MenuLink>
			</Menu>
			{missingListRolesPermCallout}
			{missingListUsersPermCallout}
		</>
	);
}
